import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import { Box, Grid, Typography } from '@mui/material';
import AppModal from 'src/components/modal';
import forms from '../../../../resources/forms.json';
import { useEffect, useRef, useState } from 'react';
import { useSiteContactInfo } from '../../steps/useSitecontactinfo';
import { useAppSelector } from 'src/store';
import { useIPManagement } from '../useIPManagement';
import { useGetAllDepotsMutation } from 'src/services/DrugSupply';
import { useUtil } from 'src/components/hooks/useUtil';
import { useAppDispatch } from 'src/store';
import { setMessage } from 'src/store/Message';
import ProgressBar from 'src/components/common/ProgressBar';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';

const IpMangementSubmitModal: React.FunctionComponent<any> = props => {
  const { openSubmitModal, setOpenSubmitModal, user, setSiteSubmitSuccess } = props;
  const {
    getIpSupplySendMailDataQueryData,
    getIpSupplySendMailDataSucess,
    getIpSupplySendMailDataError,
    getIpSupplySendMailDataLoading,
    getIpSupplyOrderQueryData,
    ipSupplyOrderQueryData,
    getIpSupplyOrderLoading,
    selectIpResupply,
    selectIpResupplyData,
    selectIpResupplyIsLoading,
    selectIpResupplyIsSuccess
  } = useIPManagement();
  const [getAllDepots, { data: depotsData, isLoading: getAllDepotsisLoading, isSuccess: getAllDepotsisSuccess }] =
    useGetAllDepotsMutation();
  const { siteStudyPersonnelQueryData, siteStudyPersonnelQueryDataError, getSiteStudyPersonnelQueryData } =
    useSiteContactInfo();
  const [protocolNo, setProtocolNo] = useState<any>();
  const [countOfOrders, setCountOfOrders] = useState<any>();
  const [treatmentNo, setTreatmentNo] = useState<any>();
  const [pharmacyAddress, setPharmacyAddress] = useState<any>();
  const [isLoading, setIsLoading] = useState<any>(false);
  const selectResupplyData: any = useAppSelector(state => state.drugSupplySlice.selectedResupply);

  const [sponsorEmails, setSponorEmails] = useState([]);
  const formGroup = (forms as any).ipManagementSubmit;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups);
  const formRef: any = useRef(null);
  const { groups } = formFields;
  const [initialValues, setInitialValues] = useState({ ...defaultValues, is_send_completed_supply_depot: false });
  const [tempId, setTempId] = useState(0);
  const { selectedApp } = useSelectedAppInfo();
  const currentApp = selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG ? 'CONDUCT' : 'STARTUP';
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;

  const dispatch = useAppDispatch();
  const { handleError, showSuccess } = useUtil();
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const [okButtonDisable, setOkButtonDisable] = useState(true);
  const treatmentNumberValue = () => {
    if (!getIpSupplyOrderLoading && currentApp === 'STARTUP' && ipSupplyOrderQueryData?.ip_open_label) {
      return treatmentNo;
    } else if (selectIpResupplyData?.ip_open_label && currentApp !== 'STARTUP' && !selectIpResupplyIsLoading) {
      return treatmentNo;
    }
    return '';
  };

  const requestData = [
    {
      textValue: 'Protocol Number',
      value: protocolNo,
      display: true
    },
    {
      textValue: 'Count of Orders',
      value: countOfOrders,
      display: true
    },
    {
      textValue: 'Treatment Number',
      value: treatmentNumberValue(),
      display: true
    },
    {
      textValue: 'Pharmacy Address',
      value: pharmacyAddress,
      display: true
    }
  ];

  const handleSave = () => {
    formRef.current.submit(onSave);
  };

  const onSave = (details: any) => {
    if (details.errors) {
      dispatch(setMessage({ msgDetails: 'Missing mandatory data', severity: 'error' }));
      return;
    }
    setSiteSubmitSuccess(false);
    const ccEmails = details.records?.cc_emails;
    const data = {
      ip_supply_id: currentApp == 'STARTUP' ? ipSupplyOrderQueryData?.id : selectResupplyData?.id,
      body: details.records?.email_body,
      sent_by: user,
      cc_mail: ccEmails,
      is_send_completed_supply_depot: details.records?.is_send_completed_supply_depot,
      recipients: [{ recipient: details.records?.send_to }]
    };
    getIpSupplySendMailDataQueryData({
      site_id: selectedSite,
      study_id: selectedStudy,
      country: selectedCountry,
      application,
      application_section: currentApp,
      data
    });
  };

  useEffect(() => {
    if (getIpSupplySendMailDataLoading || getAllDepotsisLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [getIpSupplySendMailDataLoading, getAllDepotsisLoading]);
  const getData = async () => {
    const data = await getIpSupplyOrderQueryData();
    if (data.isSuccess) {
      showSuccess(
        `${data?.data?.order_number} was created. Submitted by ${user} ${getPreferredDateTimeInLocal(
          data?.data?.submitted_on
        )}`
      );
      setOpenSubmitModal(false);
    }
  };

  const selectIpResupplyFunc = async () => {
    await selectIpResupply({
      site_id: selectedSite,
      study_id: selectedStudy,
      country: selectedCountry,
      ip_supply_id: selectResupplyData?.id,
      application: process.env.REACT_APP_NAME_TEMP,
      application_section: currentApp
    });
  };

  useEffect(() => {
    if (selectIpResupplyIsSuccess && selectIpResupplyData?.order_number) {
      showSuccess(
        `${selectIpResupplyData?.order_number} was created. Submitted by ${user} ${getPreferredDateTimeInLocal(
          selectIpResupplyData?.submitted_on
        )}`
      );
      window.scrollTo(0, 0);
      setOpenSubmitModal(false);
      setSiteSubmitSuccess(true);
    }
  }, [selectIpResupplyIsSuccess, selectIpResupplyData]);
  useEffect(() => {
    if (getIpSupplySendMailDataSucess) {
      currentApp === 'STARTUP' ? getData() : selectIpResupplyFunc();
      setSiteSubmitSuccess(true);
      //setOpenSubmitModal(false);
    }
  }, [getIpSupplySendMailDataSucess, getAllDepotsisSuccess]);

  useEffect(() => {
    if (getIpSupplySendMailDataError) {
      handleError(getIpSupplySendMailDataError);
      setIsLoading(false);
    }
  }, [getIpSupplySendMailDataError]);

  useEffect(() => {
    getAllDepots({
      study_id: selectedStudy,
      application: 'SYSADMIN',
      application_section: 'SYSADMIN',
      application_module_section: 'Master List of Studies'
    });
  }, [selectedStudy]);

  useEffect(() => {
    const found = groups[0].fields.find((item: any) => item.name === 'send_to');
    const depotEmails = depotsData?.map((e: any) => e?.depot_email);
    if (found) {
      found.values = Array.from(new Set(depotEmails));
    }
  }, [depotsData]);

  useEffect(() => {
    getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: selectedStudy,
      country: selectedCountry,
      application,
      sponsor_users: true
    });
    setTreatmentNo(null);
    setProtocolNo(null);
    setCountOfOrders(null);
    setPharmacyAddress(null);
  }, []);

  useEffect(() => {
    if (ipSupplyOrderQueryData) {
      setCountOfOrders(ipSupplyOrderQueryData?.investigational_drug_details?.length);
      if (ipSupplyOrderQueryData?.ip_open_label) {
        setTreatmentNo(ipSupplyOrderQueryData?.treatment_number);
      }
      const temp = [
        ipSupplyOrderQueryData.pharm_street_address,
        ipSupplyOrderQueryData.pharm_street_address2,
        ipSupplyOrderQueryData.pharm_city,
        ipSupplyOrderQueryData.pharm_country,
        ipSupplyOrderQueryData.pharm_zip_code
      ];
      setPharmacyAddress(temp.filter((item: any) => item).join(' '));
    }
  }, [ipSupplyOrderQueryData]);

  useEffect(() => {
    if (currentApp === 'CONDUCT') {
      selectIpResupplyFunc();
    }
  }, [currentApp]);

  useEffect(() => {
    if (selectIpResupplyData) {
      setCountOfOrders(selectIpResupplyData?.investigational_drug_details?.length);
      if (selectIpResupplyData?.ip_open_label) {
        setTreatmentNo(selectIpResupplyData?.treatment_number);
      }
      const temp = [
        selectIpResupplyData.pharm_street_address,
        selectIpResupplyData.pharm_street_address2,
        selectIpResupplyData.pharm_city,
        selectIpResupplyData.pharm_country,
        selectIpResupplyData.pharm_zip_code
      ];
      setPharmacyAddress(temp.filter((item: any) => item).join(' '));
    }
  }, [selectIpResupplyData]);

  useEffect(() => {
    if (siteStudyPersonnelQueryData) {
      setProtocolNo(siteStudyPersonnelQueryData?.study?.protocol_study_identifier);
      const temp = siteStudyPersonnelQueryData?.personnel
        .filter((item: any) => !item.site_per_role || item.site_per_role == 'Sponsor Read Only')
        .map((item: any) => {
          return { key: item.site_per_email, displayName: item.site_per_email };
        });
      setSponorEmails(Array.from(new Set(temp)));
    }
    if (siteStudyPersonnelQueryDataError) {
      setSponorEmails([]);
    }
  }, [siteStudyPersonnelQueryData, siteStudyPersonnelQueryDataError]);

  useEffect(() => {
    const found = groups[0].fields.find((item: any) => item.name === 'cc_emails');
    if (found) {
      found.values = sponsorEmails;
    }
    setInitialValues({ ...initialValues, cc_emails: sponsorEmails.map((item: any) => item.key) });
    setTempId(tempId + 1);
  }, [sponsorEmails]);

  const onChange = (key: any, value: any) => {
    initialValues[key] = value;
    setOkButtonDisable(false);
    setInitialValues(initialValues);
  };

  return (
    <>
      <AppModal
        open={openSubmitModal}
        title={formGroup.header}
        saveButton={'OK'}
        closeButton={'CANCEL'}
        handleSubmit={handleSave}
        handleClose={() => setOpenSubmitModal(false)}
        maxWidth="600px"
        loading={isLoading}
        closeButtonDisbale={isLoading}
        disabled={okButtonDisable}
        className="modalWithBlurFix"
      >
        <Box
          sx={{ '& .MuiCheckbox-root + .MuiTypography-root > .MuiTypography-root': { marginBottom: '0 !important' } }}
        >
          {isLoading && <ProgressBar />}
          <Typography variant="body1" mb="24px">
            Are you sure you want to submit? Additional changes cannot be made once submitted.
          </Typography>

          <Grid container spacing={2} rowSpacing={1} mb={2}>
            {requestData.map(
              (ele: any, index: number) =>
                ele.display && (
                  <Grid item md={6} key={index}>
                    <Typography variant="body1" sx={{ fontSize: 'clamp(14px, 15px, 16px)', wordBreak: 'break-word' }}>
                      <strong style={{ display: 'inline-block', minWidth: 'fit-content' }}>
                        {ele.textValue}:&nbsp;
                      </strong>
                      <span className="results">{ele.value}</span>
                    </Typography>
                  </Grid>
                )
            )}
          </Grid>
          <FormLayoutBuilder
            initialValues={initialValues}
            rules={rules}
            ref={formRef}
            groups={groups}
            columnSpacing={2}
            onChange={onChange}
            key={tempId}
          />
        </Box>
        <br />
      </AppModal>
    </>
  );
};

export default IpMangementSubmitModal;
